module.exports = __webpack_public_path__ + "img/company-title.72a95f3a.jpg";